module.exports = __webpack_public_path__ + "static/img/gws_jay_shankar.b454181.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gws_jay_shankar.jpeg
// module id = Whyg
// module chunks = 1